import useEmitter, { EmitterEvents, TileLabelAction } from "@/hooks/useEmitter";
import useTileRepository from "@/hooks/useTileRepository";
import useUserStore from "@/store/useUserStore";
import type { TileCoordinates } from "@/types/tile";
import { TileLabelSkin } from "@/types/tile";
import type SettlementCastleBuildingTileEntity from "./entities/buildings/SettlementCastleBuildingTileEntity";

export const revealSettlementByOffer = (): void => {
	const tilerepo = useTileRepository();
	const coordinates = tilerepo.getSettlementCoordinatesOrderedByDistance()[0];
	const settlementTile = tilerepo.getTileEntityByTileCoordinates({
		x: coordinates.x,
		y: coordinates.y,
	}) as SettlementCastleBuildingTileEntity;
	useEmitter().emit(EmitterEvents.PhaserUpdateTileLabel, {
		coordinates: {
			x: settlementTile.x,
			y: settlementTile.y,
		} as TileCoordinates,
		skin: TileLabelSkin.SETTLEMENT_HIGHLIGHT,
		action: TileLabelAction.CREATE,
	});
	useUserStore().setRevealedSettlementFromOfferCoordinates({
		x: settlementTile.x,
		y: settlementTile.y,
	} as TileCoordinates);
};
